const T = require("react").PropTypes;

const AnswerSelection = require("./AnswerSelection.js");
const Error = require("./Error.js");

const QuestionValidationStatus = require("./QuestionValidationStatus.js");

const Question = {
    /* For now, we only include props that we're actually using */
    PropType: T.shape ({
        GUID: T.string.isRequired,
        ImageUrl: T.string, 
        AnswerOptions: T.arrayOf(T.shape({
            DisplayText: T.string.isRequired,
            IncludeComment: T.bool.isRequired,
            RequireComment: T.bool.isRequired,
            ScoreValue: T.number.isRequired
        })),
        DisplayHTML: T.string.isRequired,
        DisplayOrder: T.number.isRequired,
        QuestionType: T.shape({
            BaseDisplayType: T.number.isRequired,
            Restrictions: T.number.isRequired,
            MaxAnswerSelectionCount: T.number,
            MinAnswerSelectionCount: T.number
        }),
        AnswerSelections: T.arrayOf(
            AnswerSelection.PropType),
        Required: T.bool,
        RequireComment: T.bool,
        // Processing marks
        LastChangedAt: T.number, // For tracking and debugging only
        UpdateError: Error.PropType,
        Updating: T.bool,
        UpdatedAt: T.object,
        ValidationStatus: QuestionValidationStatus.PropType,
        // For summaries
        Score: T.number,
        MaxScore: T.number,
        Task: T.string
    })
};

module.exports = Question;


// WEBPACK FOOTER //
// ./src/types/Question.js